// extracted by mini-css-extract-plugin
module.exports = {"animate-height":"NoData_animate-height__bgIUg","NoData":"NoData_NoData__155Qc","animateHeight":"NoData_animateHeight__zS0cK"};